// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* global __webpack_nonce__ */

// Don't use `const` here, since this is already a global used by webpack, and
// if it sees `const`, then it won't apply it!
//
// eslint-disable-next-line no-global-assign
__webpack_nonce__ = document.currentScript.getAttribute("webpack_nonce");

// This sets the nonce to a value that is injected by FastAPI in the template.
//
// We pull it out into a separate variable, to pass it into MUI separately than
// how webpack will handle other styles.
export const nonce = document.currentScript.getAttribute("webpack_nonce");
